<template>
  <div class="fff" ref="fff">
    <div class="tab">
      <div :class="isshow == 0 ? 'tab_li mr' : 'tab_li'" @click="isshow = 0">
        {{$t('tracking.title')}}
        <div></div>
      </div>
      <div :class="isshow == 1 ? 'tab_li mr' : 'tab_li'" @click="isshow = 1">
        {{$t('tracking.txt1')}}
        <div></div>
      </div>
    </div>
    <div class="Rules" v-show="isshow == 0" :style="{'min-height': height}">
      <div class="add_l">
        <div class="title">{{$t('tracking.txt2')}}</div>
        <div class="add_l_a">
          <div class="add_l_tit">{{$t('tracking.txt3')}}</div>
          <input v-model="key.keyword" :placeholder="$t('tracking.txt3')" />
          <div class="add_l_tit">{{$t('tracking.txt4')}}</div>
          <el-select
            v-model="key.rule_id"
            :placeholder="$t('tracking.txt4')"
            class="options"
          >
            <el-option :label="$t('All')" :value="0"></el-option>
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <!-- <input v-model="key.rule_id" value="All" class="dow"> -->
          <div class="add_l_tit">{{$t('tracking.txt5')}}</div>
          <!-- <input v-model="key.notify_id" value="Notify to email"> -->
          <el-select
            v-model="key.notify_id"
            :placeholder="$t('tracking.txt5')"
            class="options"
          >
            <el-option
              v-for="item in options1"
              :key="item.id"
              :label="item.notify_type"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <div @click="addkey()" class="loginButton RulesButton">{{$t('tracking.txt6')}}</div>
        </div>
      </div>
      <div class="add_r">
        <div class="title">{{$t('tracking.txt7')}}</div>
        <table class="mytable">
          <tr>
            <th>{{$t('tracking.txt8')}}</th>
            <th>{{$t('tracking.txt9')}}</th>
            <th>{{$t('tracking.txt10')}}</th>
            <th>{{$t('tracking.txt11')}}</th>
          </tr>
          <tr v-for="(val, key) in list" :key="key">
            <td>{{ val.keyword }}</td>
            <td>{{ val.track_rules }}</td>
            <td>{{ val.notify_type }}</td>
            <td><img @click="onDelete(val)" class="delIcon" src="@/assets/img/del.png" alt=""></td>
          </tr>
        </table>
      </div>
    </div>
    <div class="Detected" v-show="isshow == 1" :style="{'min-height': height}">
      <table class="mytable">
        <tr>
          <th>{{$t('tracking.txt12')}}</th>
          <th>{{$t('tracking.txt13')}}</th>
          <th>{{$t('tracking.txt14')}}</th>
        </tr>
        <tr v-for="(val, key) in list1" :key="key">
          <td>{{ val.content }}</td>
          <td>{{ val.name }}</td>
          <td>{{ val.time_show }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import {
  KeytrackingGetDetected,
  KeytrackingGetKeywords,
  KeytrackingInsertKeytracking,
  // eslint-disable-next-line no-unused-vars
  KeytrackingGetRules,
  KeytrackingGetNotify,
  AllApp,
  delettrackkey
} from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      isshow: 0,
      list: [],
      list1: [],
      key: {
        equipment_id: localStorage.getItem('systemId'),
        notify_id: null,
        rule_id: 0,
        keyword: ''
      },
      options: [],
      options1: [],
      msg: ''
    }
  },
  mounted () {
    this.getlist()
  },
  methods: {
    getlist () {
      // KeytrackingGetRules({equipment_id: localStorage.getItem('systemId')}).then((adj) => {
      //   console.log(adj)
      //   this.options = adj.data
      //   this.key.rule_id = adj.data[0].id
      // })
      AllApp({ equipment_id: localStorage.getItem('systemId') }).then((adj) => {
        console.log(adj)
        this.options = adj.data.list
        // this.key.rule_id = adj.data.list[0].id
      })
      KeytrackingGetNotify({
        equipment_id: localStorage.getItem('systemId')
      }).then((adj) => {
        this.options1 = adj.data
        this.key.notify_id = adj.data[0].id
      })
      KeytrackingGetKeywords({
        equipment_id: localStorage.getItem('systemId')
      }).then((adj) => {
        this.list = adj.data.list
      })
      let key = {
        equipment_id: localStorage.getItem('systemId'),
        page: 1,
        limit: 9999999
      }
      KeytrackingGetDetected(key).then((adj) => {
        this.list1 = adj.data
        this.$nextTick(() => {
          this.height = `calc(${this.$refs.fff.clientHeight}px - 61px)`
        })
      })
    },
    addkey () {
      KeytrackingInsertKeytracking(this.key).then((adj) => {
        if (adj.code !== 1) {
          this.$message({
            message: adj.msg,
            type: 'error'
          })
        }
        this.key.keyword = ''
        this.getlist()
      })
    },
    // 删除
    onDelete(val){
      let key = {
        equipment_id: localStorage.getItem('systemId'),
        id:val.id
      }
      delettrackkey(key).then((adj) => {
        if(adj.code === 1){
          this.getlist();
        } else {
          this.$message.error(adj.msg)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
  padding-bottom: 0;
  min-height: auto !important;
}
.delIcon{
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.Rules {
  overflow: hidden;
  position: relative;
}
.add_l {
  width: 35%;
  position: absolute;
  left: 0;
  top: 0;
}
.add_r {
  width: 65%;
  float: right;
  min-height: 600px;
  border-left: 1px solid #e1e3e6;
  padding-bottom: 60px;
}
.title {
  padding-top: 10px;
  height: 58px;
  text-indent: 7.5%;
  line-height: 58px;
  font-size: 16px;
  color: #000927;
  font-weight: 700;
}
.add_r .title {
  text-indent: 4%;
  border-bottom: 1px solid #e1e3e6;
}
.add_l_a {
  width: 85%;
  margin: 0 auto;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
}
.add_l_tit {
  line-height: 30px;
  padding-top: 10px;

  text-indent: 6%;
  font-size: 12px;
  font-family: Noto Sans;
}
.add_l_a input {
  display: block;
  width: 88%;
  margin: 0 auto;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  height: 34px;
  line-height: 34px;
  background: #f6f8fa;
  text-indent: 10px;
  font-size: 13px !important;
  font-family: Noto Sans;
}
.add_l_a input.dow {
  background-image: url(/src/assets/img/dow.png);
  background-size: 16px;
  background-repeat: no-repeat;
  background-position: 100%;
  background-position-x: 96%;
}
.RulesButton {
  width: 88%;
  margin: 30px auto;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
.mytable {
  width: 92%;
}
.options {
  display: block;
  width: 88%;
  margin: 0 auto;
  /*  */
  border-radius: 12px;
  height: 34px;
  line-height: 34px;
  background: #f6f8fa;
  font-size: 12px;
}

.options input {
  font-size: 12px !important;
}

.options .el-select > .el-input {
  background: none;
  border-radius: 12px;
}
.options .el-input__icon {
  height: 34px;
  line-height: 34px;
}
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Tracking.vue